import styled from 'styled-components';
import StyledNumericIcon from './StyledNumericIcon';

const StyledThinNumber = styled(StyledNumericIcon)`
    font-weight: 400;
`;

export default StyledThinNumber;
